import { io } from 'socket.io-client';

let socket = null;
let connectionListeners = [];

export function getSocket() {
  if (!socket) {
    const url = process.env.NODE_ENV === 'development'
      ? 'http://localhost:3001'
      : undefined;

    // Get or create persistent guest ID for reconnection
    const GUEST_ID_KEY = 'ovg_guest_id';
    let guestId = sessionStorage.getItem(GUEST_ID_KEY);
    if (!guestId) {
      guestId = 'guest_' + Math.random().toString(36).substring(2, 14);
      sessionStorage.setItem(GUEST_ID_KEY, guestId);
    }

    socket = io(url || window.location.origin, {
      withCredentials: true,
      autoConnect: false,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      reconnectionAttempts: 20,
      timeout: 30000,
      auth: { guestId },
    });

    // Global connection state events
    socket.on('connect', () => {
      _notifyListeners('connected');
    });

    socket.on('disconnect', (reason) => {
      _notifyListeners('disconnected', reason);
    });

    socket.on('reconnect_attempt', (attempt) => {
      _notifyListeners('reconnecting', attempt);
    });

    socket.on('reconnect', () => {
      _notifyListeners('connected');
    });

    socket.on('reconnect_failed', () => {
      _notifyListeners('failed');
    });

    socket.on('connect_error', (err) => {
      console.warn('[Socket] Connection error:', err.message);
    });
  }
  return socket;
}

export function connectSocket() {
  const s = getSocket();
  if (!s.connected) {
    s.connect();
  }
  return s;
}

export function disconnectSocket() {
  if (socket && socket.connected) {
    socket.disconnect();
  }
}

/**
 * Subscribe to connection state changes.
 * Callback receives (state, detail) where state is 'connected'|'disconnected'|'reconnecting'|'failed'.
 * Returns unsubscribe function.
 */
export function onConnectionStateChange(callback) {
  connectionListeners.push(callback);
  return () => {
    connectionListeners = connectionListeners.filter(l => l !== callback);
  };
}

/**
 * Get current connection state.
 */
export function isConnected() {
  return socket?.connected || false;
}

function _notifyListeners(state, detail) {
  for (const listener of connectionListeners) {
    try { listener(state, detail); } catch (e) { /* ignore */ }
  }
}
